import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import axios from "axios";
import TablaDeudaContrixTransaccion from "./tablaDeudaContribuyentetrans";
import { ClaveSupervisor } from "../configuracionGeneral/modalClaveSupervisor";

export const ReimprimirRecibo = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const txtNumFactura = useRef();
  const btnCancela = useRef();
  const btnImprimir = useRef();

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [idCaja, setIdCaja] = useState();
  const [desde, setDesde] = useState(0);
  const [fechaPago, setFechaPago] = useState("");
  const [numFactura, setNumFactura] = useState("");
  const [factura, setFactura] = useState();
  const [facturaDet, setFacturaDet] = useState();

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      txtNumFactura.current.setAttribute("disabled", true);
      let body = {
        idcaja: idCaja,
      };
      actualizarFacturaCerrada(body);
    }
  };

  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      setDesde(0);
      txtNumFactura.current.value = "";
      setNumFactura("");
      setFechaPago("");
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    txtNumFactura.current.setAttribute("disabled", false);
    setNumFactura("");
    setFechaPago("");
    setFactura();
    props.onHideCancela();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      setDesde(0);
      SeleccionarFactura(numFactura);
    } else if (desde === 2) {
      setDesde(0);
      txtNumFactura.current.setAttribute("disabled", false);
      setNumFactura("");
      setFechaPago("");
      setFactura();
      props.onHideCancela();
    }
  };

  const actualizarFacturaCerrada = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/facturacerradaactualizar`;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "El Cambio de Status de la Factura se Realizó Exitosamente",
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        txtNumFactura.current.value = "";
        setNumFactura("");
        setFechaPago("");
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const validarNumFactura = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarTransaccion();
      }
    }
  };

  const seleccionarTransaccion = () => {
    let id = txtNumFactura.current.value;
    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectfacturacaja?numfactura=${id}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setIdCaja(response.data.idcaja);
          if (response.data.statusreverso === 0) {
            setNumFactura(response.data.numfactura);
            setFechaPago(moment(response.data.fechapago).format("YYYY-MM-DD"));
            txtNumFactura.current.setAttribute("disabled", true);
            SeleccionarFactura(response.data.numfactura);
          } else {
            setDesde(0);
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "La Factura N°: " +
                txtNumFactura.current.value +
                " ya fue Reversada",
              icono: "exito",
            });
            txtNumFactura.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        txtNumFactura.current.value = "";
        setNumFactura("");
        setFechaPago("");
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarFactura = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "factura";
    let nomid = "numfactura";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setFactura(response.data);
          seleccionarDetalleFactura(response.data);
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarDetalleFactura = (fact) => {
    setActivate(true);
    let campos = "*";
    let nomtab = "facturadetalle";
    let nomid = "idfactura";
    let valor = fact.idfactura;
    let orden = "idfacturadetalle";
    let endpoint = `${op.conexion}/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${valor}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setFacturaDet(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarImprimirRecibo = () => {
    setMostrar2(true);
  };

  const aceptaClaveSupervisor = () => {
    setMostrar2(false);
    imprimirRecibo(factura.idfactura);
  };

  const cancelaClaveSupervisor = () => {
    setMostrar2(false);
  };

  const imprimirRecibo = (idfactura) => {
    var reporte = "reciboPagoTMP";
    window.open(
      op.reportes + "reporte=" + reporte + "&factura=" + idfactura,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        txtNumFactura.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Reimprimir Recibo</h3>
        </div>
        <button
          ref={btnCancela}
          className="btn bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={handleCloseNo}
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <ClaveSupervisor
          show={mostrar2}
          supervisor="2"
          onHideCancelaSup={cancelaClaveSupervisor}
          onHideAceptaSup={aceptaClaveSupervisor}
        />
        <div
          className="titulos"
          style={{
            height: "auto",
            minHeight: "auto",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          <div className="container">
            <div className="col-sm-12 row m-0 mb-3">
              <div className="col-sm-3 col-12 px-1"></div>
              <div className="col-md-3 ml-auto">
                <div className="input-group input-group-sm col-sm-10 ml-auto">
                  <label className="form-label fw-bold">Fecha:</label> &nbsp;{" "}
                  {moment(fechaSistema).format("DD/MM/YYYY")}
                </div>
              </div>
            </div>
            <fieldset className="row border-azul rounded mx-auto">
              <legend className="float-none m-0 w-auto">
                Datos de la Factura
              </legend>
              <div className="col-md-12 row m-0 px-0">
                <div className="col-sm-3 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-receipt fa-lg px-1"></i> Número de
                      Factura:
                    </label>
                    <input
                      type="text"
                      ref={txtNumFactura}
                      autoComplete="off"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                      onKeyUp={
                        validarNumFactura
                      } /*onBlur={validarNumTransaccion}*/
                    />
                  </div>
                </div>

                <div className="col-sm-3 col-12 px-1"></div>

                <div className="col-md-6">
                  <div className="col-md-6 ml-auto">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">
                        Fecha de Pago:
                      </label>{" "}
                      &nbsp;{" "}
                      {fechaPago === ""
                        ? fechaPago
                        : moment(fechaPago).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </div>

                <div className="m-0 px-0">
                  <hr className="m-0 azulGradiant" />
                </div>

                <div className="col-md-2">
                  <div className="input-group input-group-sm">
                    <label className="form-label fw-bold">Código:</label> &nbsp;{" "}
                    {factura
                      ? factura.idcontribuyente === "0"
                        ? ""
                        : factura.idcontribuyente
                      : ""}
                  </div>
                </div>

                <div className="col-md-7">
                  <div className="input-group input-group-sm">
                    <label className="form-label fw-bold">
                      Nombre del Contribuyente:
                    </label>{" "}
                    &nbsp; {factura ? factura.nombrecontri : ""}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="col-md-10 ml-auto px-1">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">
                        Cédula o RIF:
                      </label>{" "}
                      &nbsp; {factura ? factura.cedrif : ""}
                    </div>
                  </div>
                </div>

                <div className="m-0 px-0">
                  <hr className="m-0 azulGradiant" />
                </div>

                <div className="col-md-12">
                  <div className="input-group input-group-sm">
                    <label className="form-label fw-bold">Concepto:</label>{" "}
                    &nbsp; {factura ? factura.descripcion : ""}
                  </div>
                </div>
              </div>
            </fieldset>

            <div className="col-md-12 py-1"></div>

            <fieldset className="border-azul rounded">
              <legend className="float-none m-0 w-auto">
                Deuda del Contribuyente
              </legend>
              <div className="p-0">
                <TablaDeudaContrixTransaccion
                  factura={factura}
                  deuda={facturaDet}
                  //deuda={deuda}
                />
              </div>
            </fieldset>

            <div className="col-md-12 py-1"></div>

            <div className="col-sm-12 py-1 d-flex justify-content-end  align-items-center">
              <button
                ref={btnImprimir}
                onClick={procesarImprimirRecibo}
                className="btn btn-sm rounded-pill btn-primary col-md-2"
              >
                <i className="fas fa-print"> Imprimir</i>
              </button>
              <button
                ref={btnCancela}
                onClick={cancelar}
                className="btn btn-danger btn-sm rounded-pill col-md-2"
              >
                <i className="fas fa-window-close"> Cancelar</i>
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/ingresos/modalReimprimirRecibo.js